import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUserContext } from "../../../Contexts/userContext";
import { useGlobalError } from "../../../Contexts/GlobalErrorContext";
import { loginRoute } from "../../../services/constants";

function PrivateRoute() {
  const { user, isLoading } = useUserContext();
  const navigate = useNavigate();
  const { error: globalError } = useGlobalError();

  useEffect(() => {
    if (!globalError && !isLoading && !user) {
      navigate(loginRoute || "/auth/login");
    }
  }, [user, isLoading, navigate, globalError]);

  return <Outlet />;
}

export default PrivateRoute;
